import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { ApplicationService } from '../services/application.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{

constructor(private appService: ApplicationService) { }
canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
  return this.appService.isLoggedIn.pipe( 
    take(1), 
    map((isLoggedIn: boolean) => { 
      if (!isLoggedIn) { 
        this.appService.logout(); 
        return false;
      }
      return true;
    })
  );
}


}
